<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>下单IP设备查询</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-input
          placeholder="请输入用户ID"
          clearable
          v-model="userId"
          size="mini"
          class="filter-input"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-input
          placeholder="请输入下单IP"
          clearable
          v-model.trim="orderIp"
          size="mini"
          class="filter-input"
          @keyup.enter.native="handleSearch"
        >
          <i slot="prefix" class="el-input__icon el-icon-search"></i>
        </el-input>
        <el-select
          v-model="platform"
          placeholder="设备类型"
          clearable
          size="mini"
          class="filter-select"
        >
          <el-option value="" label="全部类型"></el-option>
          <el-option
            v-for="item in platformOptions"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-date-picker
          v-model="value1"
          type="daterange"
          align="right"
          format="yyyy-MM-dd"
          value-format="timestamp"
          unlink-panels
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          :picker-options="pickerOptions"
          size="mini"
        />
        <el-button type="primary" size="mini" @click="handleSearch">搜索</el-button>
        <el-button size="mini" @click="exportExcel">导出</el-button>
      </div>
      <user-list @refresh="refreshList" />
    </el-card>
  </div>
</template>

<script>
import './store';
import UserList from './components/list';
import { mapState, mapActions } from 'vuex';
import { PAGINATION } from './constants';
import api from './api';

export default {
  name: 'userOrderLog',
  components: {
    UserList,
  },
  data() {
    return {
      userId: '',
      orderIp: '',
      platform: '',
      value1: '',
      platformOptions: [
        { value: 'IPHONE', label: 'IPHONE' },
        { value: 'WEB', label: 'WEB' },
        { value: 'ANDROID', label: 'ANDROID' },
      ],
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            },
          },
        ],
      },
    };
  },
  computed: {
    ...mapState('userOrderLog', ['pagination']),
  },
  methods: {
    ...mapActions('userOrderLog', ['list']),
    buildExportParams() {
      const data = {};
      if (this.userId !== '' && this.userId != null) {
        data.userId = this.userId;
      }
      if (this.orderIp) {
        data.orderIp = this.orderIp;
      }
      if (this.platform) {
        data.platform = this.platform;
      }
      if (this.value1 && this.value1[0]) {
        data.startTime = this.value1[0];
      }
      if (this.value1 && this.value1[1]) {
        data.endTime = this.endOfDayTimestamp(this.value1[1]);
      }
      return data;
    },
    endOfDayTimestamp(ts) {
      if (ts == null || ts === '') return '';
      const d = new Date(typeof ts === 'string' ? Number(ts) : ts);
      d.setHours(23, 59, 59, 999);
      return d.getTime();
    },
    buildQuery(extra = {}) {
      return {
        userId: this.userId,
        orderIp: this.orderIp,
        platform: this.platform,
        startTime: this.value1 ? this.value1[0] : '',
        endTime: this.value1 ? this.endOfDayTimestamp(this.value1[1]) : '',
        ...this.pagination,
        ...extra,
      };
    },
    refreshList(data = {}) {
      this.list(this.buildQuery(data));
    },
    handleSearch() {
      this.list(this.buildQuery({ ...PAGINATION }));
    },
    exportExcel() {
      api.exportUserOrderLog(this.buildExportParams()).then((res) => {
        const link = document.createElement('a');
        const blob = new Blob([res], { type: 'application/vnd.ms-excel' });
        link.style.display = 'none';
        link.href = URL.createObjectURL(blob);
        const uid = String(this.userId || '').trim();
        link.download = uid
          ? `${uid}_下单IP设备查询`
          : '下单IP设备查询';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
      });
    },
  },
  created() {
    this.list(this.buildQuery({ ...PAGINATION }));
  },
};
</script>

<style lang="less" scoped>
.filter-input {
  width: 200px;
}
.filter-select {
  width: 160px;
}
</style>
